import { Link } from '@tanstack/react-router';

import { buttonVariants } from '@/components/ui/button';

export const NotFoundPage = () => (
  <div className="flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center">
    <p className="text-6xl font-bold text-brand-violet/20">404</p>
    <h1 className="text-xl font-semibold">Page introuvable</h1>
    <p className="text-sm text-muted-foreground">Cette adresse ne correspond à aucune page de l'admin plateforme.</p>
    <Link to="/" className={buttonVariants({ variant: 'outline', className: 'mt-2' })}>
      Retour à l'accueil
    </Link>
  </div>
);
